/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAmpUser = /* GraphQL */ `
  query GetAmpUser($id: ID!) {
    getAmpUser(id: $id) {
      id
      internalTrackingId
      anonymizedId
      email
      owner
      anonymizedOwner
      username
      anonymizedUsername
      userStatus
      ampUserTypes
      lastLoginDateTimeUTC
      lastLoginDateTimeLocal
      lastLoginTimestampUTC
      lastLoginTimestampLocal
      name
      phone
      phoneE1164
      alternatePhone
      alternatePhoneE1164
      address
      city
      state
      zip
      country
      streetAddress
      alternateContactName
      alternateContactPhone
      alternateContactPhoneE164
      lastPaymentHash
      lastSubSuccessPageSyncTimestampUTC
      lastSubSuccessPageSyncTimestampLocal
      intakeFormCompleted
      routerPath
      sharedRouterPath
      isEdited
      lastEditedAtDateTimeUTC
      lastEditedAtDateTimeLocal
      lastEditedAtTimestampUTC
      lastEditedAtTimestampLocal
      isDeleted
      isArchived
      isAnonymized
      waitlistUserIdField
      anonymizedWaitlistUserIdField
      createdAt
      updatedAt
    }
  }
`;
export const listAmpUsers = /* GraphQL */ `
  query ListAmpUsers(
    $filter: ModelAmpUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmpUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        internalTrackingId
        anonymizedId
        email
        owner
        anonymizedOwner
        username
        anonymizedUsername
        userStatus
        ampUserTypes
        lastLoginDateTimeUTC
        lastLoginDateTimeLocal
        lastLoginTimestampUTC
        lastLoginTimestampLocal
        name
        phone
        phoneE1164
        alternatePhone
        alternatePhoneE1164
        address
        city
        state
        zip
        country
        streetAddress
        alternateContactName
        alternateContactPhone
        alternateContactPhoneE164
        lastPaymentHash
        lastSubSuccessPageSyncTimestampUTC
        lastSubSuccessPageSyncTimestampLocal
        intakeFormCompleted
        routerPath
        sharedRouterPath
        isEdited
        lastEditedAtDateTimeUTC
        lastEditedAtDateTimeLocal
        lastEditedAtTimestampUTC
        lastEditedAtTimestampLocal
        isDeleted
        isArchived
        isAnonymized
        waitlistUserIdField
        anonymizedWaitlistUserIdField
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAmpUserSharedProfile = /* GraphQL */ `
  query GetAmpUserSharedProfile($id: ID!) {
    getAmpUserSharedProfile(id: $id) {
      id
      internalTrackingId
      anonymizedId
      owner
      anonymizedOwner
      isEdited
      isSharedPublic
      isSharedPrivate
      sharedPrivateAmpUserIdFields
      sharedProfileName
      sharedProfileEmail
      sharedProfilePhone
      sharedProfilePhoneE164
      sharedProfileAlternatePhone
      sharedProfileAlternatePhoneE164
      sharedProfileAddress
      sharedProfileCity
      sharedProfileState
      sharedProfileZip
      sharedProfileCountry
      sharedProfileStreetAddress
      sharedProfileAlternateContactName
      sharedProfileAlternateContactPhone
      sharedProfileAlternateContactPhoneE164
      sharedProfileDescription
      sharedProfileImage
      sharedProfileImageEtag
      sharedProfileImageKey
      sharedProfileImageLastEditedDateTimeUTC
      sharedProfileImageLastEditedTimestampUTC
      sharedProfileImageLastEditedBy
      sharedProfileSharedPublicAttributes
      sharedProfileSharedPrivateAttributes
      sharedProfileMetadataObj
      sharedProfileRouterPath
      sharedProfilePublicRouterPath
      sharedProfilePrivateRouterPath
      sharedProfileLastEditedDateTimeUTC
      sharedProfileLastEditedTimestampUTC
      sharedProfileLastEditedBy
      sharedProfileLastEditedById
      isArchived
      isAnonymized
      isDeleted
      ampUserIdField
      anonymizedAmpUserIdField
      ampuserID
      createdAt
      updatedAt
    }
  }
`;
export const listAmpUserSharedProfiles = /* GraphQL */ `
  query ListAmpUserSharedProfiles(
    $filter: ModelAmpUserSharedProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmpUserSharedProfiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        internalTrackingId
        anonymizedId
        owner
        anonymizedOwner
        isEdited
        isSharedPublic
        isSharedPrivate
        sharedPrivateAmpUserIdFields
        sharedProfileName
        sharedProfileEmail
        sharedProfilePhone
        sharedProfilePhoneE164
        sharedProfileAlternatePhone
        sharedProfileAlternatePhoneE164
        sharedProfileAddress
        sharedProfileCity
        sharedProfileState
        sharedProfileZip
        sharedProfileCountry
        sharedProfileStreetAddress
        sharedProfileAlternateContactName
        sharedProfileAlternateContactPhone
        sharedProfileAlternateContactPhoneE164
        sharedProfileDescription
        sharedProfileImage
        sharedProfileImageEtag
        sharedProfileImageKey
        sharedProfileImageLastEditedDateTimeUTC
        sharedProfileImageLastEditedTimestampUTC
        sharedProfileImageLastEditedBy
        sharedProfileSharedPublicAttributes
        sharedProfileSharedPrivateAttributes
        sharedProfileMetadataObj
        sharedProfileRouterPath
        sharedProfilePublicRouterPath
        sharedProfilePrivateRouterPath
        sharedProfileLastEditedDateTimeUTC
        sharedProfileLastEditedTimestampUTC
        sharedProfileLastEditedBy
        sharedProfileLastEditedById
        isArchived
        isAnonymized
        isDeleted
        ampUserIdField
        anonymizedAmpUserIdField
        ampuserID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const ampUserSharedProfilesByAmpuserID = /* GraphQL */ `
  query AmpUserSharedProfilesByAmpuserID(
    $ampuserID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAmpUserSharedProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ampUserSharedProfilesByAmpuserID(
      ampuserID: $ampuserID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        internalTrackingId
        anonymizedId
        owner
        anonymizedOwner
        isEdited
        isSharedPublic
        isSharedPrivate
        sharedPrivateAmpUserIdFields
        sharedProfileName
        sharedProfileEmail
        sharedProfilePhone
        sharedProfilePhoneE164
        sharedProfileAlternatePhone
        sharedProfileAlternatePhoneE164
        sharedProfileAddress
        sharedProfileCity
        sharedProfileState
        sharedProfileZip
        sharedProfileCountry
        sharedProfileStreetAddress
        sharedProfileAlternateContactName
        sharedProfileAlternateContactPhone
        sharedProfileAlternateContactPhoneE164
        sharedProfileDescription
        sharedProfileImage
        sharedProfileImageEtag
        sharedProfileImageKey
        sharedProfileImageLastEditedDateTimeUTC
        sharedProfileImageLastEditedTimestampUTC
        sharedProfileImageLastEditedBy
        sharedProfileSharedPublicAttributes
        sharedProfileSharedPrivateAttributes
        sharedProfileMetadataObj
        sharedProfileRouterPath
        sharedProfilePublicRouterPath
        sharedProfilePrivateRouterPath
        sharedProfileLastEditedDateTimeUTC
        sharedProfileLastEditedTimestampUTC
        sharedProfileLastEditedBy
        sharedProfileLastEditedById
        isArchived
        isAnonymized
        isDeleted
        ampUserIdField
        anonymizedAmpUserIdField
        ampuserID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAmpUserSubscriber = /* GraphQL */ `
  query GetAmpUserSubscriber($id: ID!) {
    getAmpUserSubscriber(id: $id) {
      id
      internalTrackingId
      anonymizedId
      appAccountToken
      currentSubBeginDateTimeUTC
      currentSubBeginDateTimeLocal
      currentSubBeginTimestampUTC
      currentSubBeginTimestampLocal
      currentSubBeginDateUTC
      currentSubBeginDateLocal
      currentSubEndDateTimeUTC
      currentSubEndDateTimeLocal
      currentSubEndTimestampUTC
      currentSubEndTimestampLocal
      currentSubEndDateUTC
      currentSubEndDateLocal
      currentSubUserStatus
      currentSubUserSubStatus
      currentUserSubImagePeriodQuotaIdField
      currentUserSubImagePeriodAnimalQuotaIdField
      subIsActive
      ampUserLastPaymentHash
      lastSubSuccessPageSyncTimestampUTC
      lastSubSuccessPageSyncTimestampLocal
      isEdited
      lastEditedDateTimeUTC
      lastEditedDateTimeLocal
      lastEditedTimestampUTC
      lastEditedTimestampLocal
      isArchived
      isAnonymized
      isDeleted
      owner
      anonymizedOwner
      ampUserIdField
      anonymizedAmpUserIdField
      vaultOwnerIdField
      anonymizedVaultOwnerIdField
      currentUserSubIdField
      lastUserSubIdField
      ampuserID
      createdAt
      updatedAt
    }
  }
`;
export const listAmpUserSubscribers = /* GraphQL */ `
  query ListAmpUserSubscribers(
    $filter: ModelAmpUserSubscriberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmpUserSubscribers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        internalTrackingId
        anonymizedId
        appAccountToken
        currentSubBeginDateTimeUTC
        currentSubBeginDateTimeLocal
        currentSubBeginTimestampUTC
        currentSubBeginTimestampLocal
        currentSubBeginDateUTC
        currentSubBeginDateLocal
        currentSubEndDateTimeUTC
        currentSubEndDateTimeLocal
        currentSubEndTimestampUTC
        currentSubEndTimestampLocal
        currentSubEndDateUTC
        currentSubEndDateLocal
        currentSubUserStatus
        currentSubUserSubStatus
        currentUserSubImagePeriodQuotaIdField
        currentUserSubImagePeriodAnimalQuotaIdField
        subIsActive
        ampUserLastPaymentHash
        lastSubSuccessPageSyncTimestampUTC
        lastSubSuccessPageSyncTimestampLocal
        isEdited
        lastEditedDateTimeUTC
        lastEditedDateTimeLocal
        lastEditedTimestampUTC
        lastEditedTimestampLocal
        isArchived
        isAnonymized
        isDeleted
        owner
        anonymizedOwner
        ampUserIdField
        anonymizedAmpUserIdField
        vaultOwnerIdField
        anonymizedVaultOwnerIdField
        currentUserSubIdField
        lastUserSubIdField
        ampuserID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const ampUserSubscribersByAmpuserID = /* GraphQL */ `
  query AmpUserSubscribersByAmpuserID(
    $ampuserID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAmpUserSubscriberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ampUserSubscribersByAmpuserID(
      ampuserID: $ampuserID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        internalTrackingId
        anonymizedId
        appAccountToken
        currentSubBeginDateTimeUTC
        currentSubBeginDateTimeLocal
        currentSubBeginTimestampUTC
        currentSubBeginTimestampLocal
        currentSubBeginDateUTC
        currentSubBeginDateLocal
        currentSubEndDateTimeUTC
        currentSubEndDateTimeLocal
        currentSubEndTimestampUTC
        currentSubEndTimestampLocal
        currentSubEndDateUTC
        currentSubEndDateLocal
        currentSubUserStatus
        currentSubUserSubStatus
        currentUserSubImagePeriodQuotaIdField
        currentUserSubImagePeriodAnimalQuotaIdField
        subIsActive
        ampUserLastPaymentHash
        lastSubSuccessPageSyncTimestampUTC
        lastSubSuccessPageSyncTimestampLocal
        isEdited
        lastEditedDateTimeUTC
        lastEditedDateTimeLocal
        lastEditedTimestampUTC
        lastEditedTimestampLocal
        isArchived
        isAnonymized
        isDeleted
        owner
        anonymizedOwner
        ampUserIdField
        anonymizedAmpUserIdField
        vaultOwnerIdField
        anonymizedVaultOwnerIdField
        currentUserSubIdField
        lastUserSubIdField
        ampuserID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getContactSubmission = /* GraphQL */ `
  query GetContactSubmission($id: ID!) {
    getContactSubmission(id: $id) {
      id
      contactSubmissionType
      email
      subject
      contactSubmissionSubject
      message
      contactSubmissionMessage
      contactSubmissionStatus
      owner
      createdAt
      updatedAt
    }
  }
`;
export const listContactSubmissions = /* GraphQL */ `
  query ListContactSubmissions(
    $filter: ModelContactSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactSubmissions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contactSubmissionType
        email
        subject
        contactSubmissionSubject
        message
        contactSubmissionMessage
        contactSubmissionStatus
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const submissionsByType = /* GraphQL */ `
  query SubmissionsByType(
    $contactSubmissionType: SubmissionType!
    $sortDirection: ModelSortDirection
    $filter: ModelContactSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    submissionsByType(
      contactSubmissionType: $contactSubmissionType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contactSubmissionType
        email
        subject
        contactSubmissionSubject
        message
        contactSubmissionMessage
        contactSubmissionStatus
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const submissionsByStatus = /* GraphQL */ `
  query SubmissionsByStatus(
    $contactSubmissionStatus: SubmissionStatus!
    $sortDirection: ModelSortDirection
    $filter: ModelContactSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    submissionsByStatus(
      contactSubmissionStatus: $contactSubmissionStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contactSubmissionType
        email
        subject
        contactSubmissionSubject
        message
        contactSubmissionMessage
        contactSubmissionStatus
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
